import { Injectable } from '@angular/core';
import { ProgresoTimeoutService } from 'src/app/auth/services/timeout-service';

@Injectable({
  providedIn: 'root',
})
export class IframeService {
  constructor(
    private _timeoutService: ProgresoTimeoutService,
  ) { }

  public findAndRegisterFrames(body: any) {
    if (!body) {
      return;
    }

    const iframes: any = body.getElementsByTagName('iframe');
    for (const iframe of iframes) {
      if (
        iframe &&
        iframe.contentDocument &&
        iframe.contentDocument.body &&
        iframe.contentDocument.readyState === 'complete'
      ) {
        iframe.contentDocument.body.onclick = () => {
          this._timeoutService.resetTimer();
        };
        iframe.contentDocument.onmouseover = iframe.contentDocument.onmouseout = iframe.contentDocument.onmousemove = () => {
          this._timeoutService.resetTimer();
        };

        iframe.addEventListener('load', () => {
          this._timeoutService.resetTimer();

          if (iframe.contentWindow.document.body) {
            iframe.height = iframe.contentWindow.document.body.scrollHeight;
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight;
          }
          setTimeout(() => {
            try {
              (<any>window.top).initIframeResize();
            } catch (e) { }
          });

          iframe.contentDocument.body.onclick = () => {
            this._timeoutService.resetTimer();
          };
          iframe.contentDocument.onmouseover = iframe.contentDocument.onmouseout = iframe.contentDocument.onmousemove = () => {
            this._timeoutService.resetTimer();
          };
          setTimeout(() =>
            this.findAndRegisterFrames(iframe.contentDocument.body)
          );
        });
        setTimeout(() =>
          this.findAndRegisterFrames(iframe.contentDocument.body)
        );
      }
      else {
        setTimeout(() => {
          if (window.top.document) {
            this.findAndRegisterFrames(window.top.document.body)
          }
        }, 1000);
      }
    }
  }

  public findAndRegisterFramesForModalResize(body: any) {
    if (!body) {
      return;
    }

    const iframes: any = body.getElementsByTagName('iframe');
    for (const iframe of iframes) {
      if (
        iframe &&
        iframe.contentDocument &&
        iframe.contentWindow &&
        iframe.contentWindow.document &&
        iframe.contentDocument.body &&
        iframe.contentDocument.readyState === 'complete'
      ) {
        iframe.contentDocument.body.onclick = () => {
          this._timeoutService.resetTimer();
          if (iframe.contentWindow.document.body) {
            iframe.height = iframe.contentWindow.document.body.scrollHeight;
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight;
          }
        };
        iframe.contentDocument.onmouseover = iframe.contentDocument.onmouseout = iframe.contentDocument.onmousemove = () => {
          this._timeoutService.resetTimer();
          if (iframe.contentWindow.document.body) {
            iframe.height = iframe.contentWindow.document.body.scrollHeight;
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight;
          }
        };

        iframe.addEventListener('load', () => {
          this._timeoutService.resetTimer();
          if (iframe.contentWindow.document.body) {
            iframe.height = iframe.contentWindow.document.body.scrollHeight;
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight;
          }
          iframe.contentDocument.body.onclick = () => {
            this._timeoutService.resetTimer();
            if (iframe.contentWindow.document.body) {
              iframe.height = iframe.contentWindow.document.body.scrollHeight;
              iframe.style.height = iframe.contentWindow.document.body.scrollHeight;
            }
          };
          iframe.contentDocument.onmouseover = iframe.contentDocument.onmouseout = iframe.contentDocument.onmousemove = () => {
            this._timeoutService.resetTimer();
            if (iframe.contentWindow.document.body) {
              iframe.height = iframe.contentWindow.document.body.scrollHeight;
              iframe.style.height = iframe.contentWindow.document.body.scrollHeight;
            }
          };
          setTimeout(() =>
            this.findAndRegisterFramesForModalResize(iframe.contentDocument.body)
          );
        });

        setTimeout(() =>
          this.findAndRegisterFramesForModalResize(iframe.contentDocument.body)
        );
      }
      else {
        setTimeout(() =>
          this.findAndRegisterFramesForModalResize(body)
        );
      }
    }
  }
}
